module.exports = __webpack_public_path__ + "static/img/cha-page-06.3c52185.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cha/cha-page-06.png
// module id = rgvq
// module chunks = 1